module.exports = __webpack_public_path__ + "img/es.8418b57b.svg";